import React from 'react';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch/Switch';
import Typography from '@material-ui/core/Typography/Typography';
import Button from '@material-ui/core/Button/Button';
import { withStyles } from '@material-ui/core/styles';
import { convertPrice } from '../utils';

const styles = {
  container: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 5px 0 rgba(0,0,0,0.26), 0 0 7px 0 rgba(178,178,178,0.5)',
    margin: '0 !important',
  },
  colorSwitchBase: {
    color: '#FF9200',
    '&$colorChecked': {
      color: '#FF9200',
    },
  },
  colorChecked: {},
  colorBar: {
    backgroundColor: '#FF9200 !important',
    opacity: 0.5,
  },
  switchContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(237,237,237,0.3)',
    padding: '4px 0 !important',
    '&& > p': {
      color: 'rgba(33,35,34,0.5)',
      fontSize: 14,
      textTransform: 'uppercase',
      fontWeight: 500,
    },
    '&& > span': {},
  },
  selected: {
    color: '#FF9200 !important',
  },
  padded: {
    padding: '0 15px !important',
  },
  flexed: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  item: {},
  itemHeader: {
    color: '#212322 !important',
    margin: '15px 0 !important',
    fontWeight: '500 !important',
  },
  itemSubItem: {
    marginBottom: '11px !important',
    '&& > p:nth-child(1)': {
      fontSize: 12,
      color: '#FF9200',
    },
    '&& > p:nth-child(2)': {
      fontSize: 13,
      fontWeight: 500,
      color: '#212322',
    },
  },
  itemTotal: {
    backgroundColor: 'rgba(237,237,237,0.3)',
    paddingTop: '7px !important',
    paddingBottom: '9px !important',
    borderBottom: '1px solid #EDEDED',
    '&& > p': {
      color: '#212322',
      fontWeight: '500',
    },
    '&& > p:nth-child(1)': {
      fontSize: 14,
    },
    '&& > p:nth-child(2)': {
      fontSize: 13,
    },
  },
  grandTotal: {
    paddingTop: '12px !important',
    paddingBottom: '17px !important',
    '&& > p:nth-child(1)': {
      color: '#212322',
      fontSize: 14,
      fontWeight: '500',

    },
    '&& > p:nth-child(2)': {
      color: '#FF9200',
      fontWeight: '300',
      fontSize: 20,
    },
  },
  action: {
    textAlign: 'center',
    paddingBottom: '17px !important',
  },
};

export const PlanSummary = ({ paymentPeriod, items: { currency, sum, products }, onSwitch, classes, onSubmit }) => {
  return (
    <Grid container spacing={5} className={classes.container} direction="column">
      <Grid item className={classes.switchContainer}>
        <Typography className={paymentPeriod === 'month' ? classes.selected : null}>monthly</Typography>
        <Switch
          checked={paymentPeriod === 'year'}
          onChange={onSwitch}
          value="paymentPeriod"
          data-testid="payment-period-toggle"
          classes={{
            switchBase: classes.colorSwitchBase,
            track: classes.colorBar,
            checked: classes.colorChecked,
          }}
        />
        <Typography className={paymentPeriod !== 'month' ? classes.selected : null}>yearly</Typography>
      </Grid>

      {products.map(product => <div key={product.name}>

        <Typography className={`${classes.itemHeader} ${classes.padded}`}>
          {product.name}
        </Typography>
        {product.items.map(item => <Grid key={item.name}
          className={`${classes.itemSubItem} ${classes.padded} ${classes.flexed}`}>
          <Typography>
            {item.name}
          </Typography>
          <Typography>
            {convertPrice(item.sum, currency)}/{paymentPeriod}
          </Typography>
        </Grid>)}
        <Grid item className={`${classes.itemTotal} ${classes.padded} ${classes.flexed}`}>
          <Typography>
            Total
          </Typography>
          <Typography>
            {convertPrice(product.sum, currency)}/{paymentPeriod}
          </Typography>
        </Grid>
      </div>)}
      <Grid item className={`${classes.grandTotal} ${classes.padded} ${classes.flexed}`}>
        <Typography>
          Grand Total
        </Typography>
        <Typography>
          {convertPrice(sum, currency)}/{paymentPeriod}
        </Typography>
      </Grid>
      <Grid item className={`${classes.action} ${classes.padded}`}>
        <Button
          color="secondary"
          variant="contained"
          data-testid="start-subscription-button-first"
          disabled={!products[0].sum}
          onClick={() => onSubmit()}>
          Get started
        </Button>
        {!products[0].sum ?
          <Typography>You can't start your subscription, because you have no domains added. Please add consent solution.
          </Typography> : null}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(PlanSummary);
